import { SkillSubStates } from '../models/SkillState';

export const inferredOrDiscrepancy = (subState: string) => {
  if (
    subState === SkillSubStates.INFERRED_VIA_ASSESSMENT ||
    subState === SkillSubStates.INFERRED_VIA_DIAGNOSTIC ||
    subState === SkillSubStates.INFERRED_VIA_EXITSLIP ||
    subState === SkillSubStates.DISCREPANCY_ASSESSMENT_ASSESSMENT ||
    subState === SkillSubStates.DISCREPANCY_DIAGNOSTIC_ASSESSMENT ||
    subState === SkillSubStates.DISCREPANCY_DIAGNOSTIC_DIAGNOSTIC ||
    subState === SkillSubStates.DISCREPANCY_EXITSLIP_ASSESSMENT ||
    subState === SkillSubStates.DISCREPANCY_EXITSLIP_DIAGNOSTIC
  ) {
    return true;
  } else {
    return false;
  }
};
